import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, LocalOffer } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy } from 'services/WService';

//modal
import ModalDiscountScale from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import FilterArticle from 'hooks/FilterArticle';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'ID', accessor: 'id' },
  { Header: 'Cód. proveedor', accessor: 'CardCode' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Nombre categoría', accessor: 'category' },
  { Header: 'Nombre familia', accessor: 'family' },
  { Header: 'Cód. Producto', accessor: 'ItemCode' },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Mesa', accessor: 'base_bureau_description' },
  { Header: 'Canal', accessor: 'base_canal_description' },
  { Header: 'Cant. Min', accessor: 'quantity_min' },
  { Header: 'Cant. Max', accessor: 'quantity_max' },
  { Header: 'Descuento', accessor: 'discount' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function DiscountScale(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [dScales, setDScales] = useState([]); //constante para el listado
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  async function loadDiscountScales(filter) {
    setDataLoading(true);
    let response = await wsFindBy('logi/discount-scale', filter);
    setDataLoading(false);
    if (response.success) setDScales(response.data);
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalDiscountScale
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => loadDiscountScales(valueSearch)}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_PRODUCT_DISCOUNT_SCALES_STORE}
              component={
                <CardIcon color="primary">
                  <LocalOffer style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de descuento en escala {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterArticle
              getFilter={loadDiscountScales}
              setValueSearch={setValueSearch}
              mark
              article
              zone
              bureau
              canal
              state
            />

            <ReactTable
              excelName="Escala-de-descuentos"
              defaultWidth={2500}
              indexRow={[0, 1, 2, 3, 4, 5, 6, 7, 15]}
              widthRow={[120, 80, 150, 300, 250, 250, 150, 300, 5]}
              columns={columns}
              data={dScales.map((dScale, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.LOGI_PRODUCT_DISCOUNT_SCALES_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(dScale)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.LOGI_PRODUCT_DISCOUNT_SCALES_DELETED}
                      >
                        <ButtonDelete
                          entity="logi/discount-scale"
                          id={dScale.id}
                          reload={loadDiscountScales}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  id: dScale.id.toString(),
                  CardCode: dScale.CardCode,
                  CardName: dScale.CardName,
                  category: dScale.logi_category_description,
                  family: dScale.logi_family_description,
                  ItemCode: dScale.ItemCode,
                  ItemName: dScale.ItemName,
                  base_zone_description: dScale.base_zone_description,
                  base_bureau_description:
                    dScale.base_bureau_description === null
                      ? 'Todos'
                      : dScale.base_bureau_description,
                  base_canal_description: dScale.base_canal_description,
                  quantity_min: dScale.quantity_min,
                  quantity_max: dScale.quantity_max,
                  discount: dScale.discount + ' %',
                  state: dScale.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
